// @generated by protoc-gen-es v1.3.3 with parameter "target=js+dts,import_extension=none"
// @generated from file common/v1/payment.proto (package common.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { CardTypeIndicators, LpmType } from "./common_pb";

/**
 * @generated from enum common.v1.DynamicDepositAccountType
 */
export const DynamicDepositAccountType = proto3.makeEnum(
  "common.v1.DynamicDepositAccountType",
  [
    {no: 0, name: "DYNAMIC_DEPOSIT_ACCOUNT_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "DYNAMIC_DEPOSIT_ACCOUNT_TYPE_SAVING", localName: "SAVING"},
    {no: 2, name: "DYNAMIC_DEPOSIT_ACCOUNT_TYPE_CHECKING", localName: "CHECKING"},
    {no: 3, name: "DYNAMIC_DEPOSIT_ACCOUNT_TYPE_CORPORATE_CHECKING", localName: "CORPORATE_CHECKING"},
  ],
);

/**
 * @generated from enum common.v1.PaymentMethodTypeCode
 */
export const PaymentMethodTypeCode = proto3.makeEnum(
  "common.v1.PaymentMethodTypeCode",
  [
    {no: 0, name: "PAYMENT_METHOD_TYPE_CODE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "PAYMENT_METHOD_TYPE_CODE_CARD", localName: "CARD"},
    {no: 2, name: "PAYMENT_METHOD_TYPE_CODE_ELECTRONIC_CHECK", localName: "ELECTRONIC_CHECK"},
    {no: 3, name: "PAYMENT_METHOD_TYPE_CODE_APPLE_PAY", localName: "APPLE_PAY"},
    {no: 4, name: "PAYMENT_METHOD_TYPE_CODE_SEPA", localName: "SEPA"},
    {no: 5, name: "PAYMENT_METHOD_TYPE_CODE_GOOGLE_PAY", localName: "GOOGLE_PAY"},
    {no: 6, name: "PAYMENT_METHOD_TYPE_CODE_PAZE", localName: "PAZE"},
    {no: 7, name: "PAYMENT_METHOD_TYPE_CODE_LPM", localName: "LPM"},
    {no: 8, name: "PAYMENT_METHOD_TYPE_CODE_PAY_BY_BANK", localName: "PAY_BY_BANK"},
    {no: 9, name: "PAYMENT_METHOD_TYPE_CODE_CREDIT_CARD", localName: "CREDIT_CARD"},
    {no: 10, name: "PAYMENT_METHOD_TYPE_CODE_DEBIT_CARD", localName: "DEBIT_CARD"},
  ],
);

/**
 * @generated from message common.v1.ElectronicCheck
 */
export const ElectronicCheck = proto3.makeMessageType(
  "common.v1.ElectronicCheck",
  () => [
    { no: 1, name: "financial_institution_routing_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "account_type", kind: "enum", T: proto3.getEnumType(DynamicDepositAccountType) },
    { no: 3, name: "masked_account_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "account_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message common.v1.Card
 */
export const Card = proto3.makeMessageType(
  "common.v1.Card",
  () => [
    { no: 1, name: "card_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "card_type_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "card_expiration_month", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "card_expiration_year", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "card_type_indicators", kind: "message", T: CardTypeIndicators },
    { no: 6, name: "last_4_of_card_pan", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "masked_account_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "pin_number", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * @generated from message common.v1.DigitalWallet
 */
export const DigitalWallet = proto3.makeMessageType(
  "common.v1.DigitalWallet",
  () => [
    { no: 1, name: "card_expiration_month", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "card_expiration_year", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "last_4_of_card_pan", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "three_ds_eci_indicator", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "three_ds_online_payment_cryptogram", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message common.v1.Sepa
 */
export const Sepa = proto3.makeMessageType(
  "common.v1.Sepa",
  () => [
    { no: 1, name: "bic", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "shopper_email_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "masked_account_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * Defines LPM details to be used in Notifications
 *
 * @generated from message common.v1.LpmDetails
 */
export const LpmDetails = proto3.makeMessageType(
  "common.v1.LpmDetails",
  () => [
    { no: 1, name: "lpm_type", kind: "enum", T: proto3.getEnumType(LpmType) },
    { no: 2, name: "merchant_return_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "lpm_orchestration_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "secret_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "timestamp_returned", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "funding_status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "payment_arrangement_expiration_timestamp", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "international_business_identifier_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "full_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message common.v1.PayByBankResponse
 */
export const PayByBankResponse = proto3.makeMessageType(
  "common.v1.PayByBankResponse",
  () => [
    { no: 1, name: "last4digits_of_account_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "account_type", kind: "enum", T: proto3.getEnumType(DynamicDepositAccountType) },
    { no: 3, name: "pay_by_bank_request_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "account_token_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "account_holder_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "bank_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "financial_institution_routing_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "masked_account_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "institutional_logo", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "alt_institutional_logo", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message common.v1.PaymentMethod
 */
export const PaymentMethod = proto3.makeMessageType(
  "common.v1.PaymentMethod",
  () => [
    { no: 1, name: "payment_method_type", kind: "enum", T: proto3.getEnumType(PaymentMethodTypeCode) },
    { no: 2, name: "card", kind: "message", T: Card },
    { no: 3, name: "electronic_check", kind: "message", T: ElectronicCheck },
    { no: 4, name: "sepa", kind: "message", T: Sepa },
    { no: 5, name: "lpm", kind: "message", T: LpmDetails },
    { no: 6, name: "pay_by_bank", kind: "message", T: PayByBankResponse },
    { no: 7, name: "digital_wallet", kind: "message", T: DigitalWallet },
  ],
);

